import { render, staticRenderFns } from "./NameInitialsIcon.vue?vue&type=template&id=d528eb50&scoped=true&"
import script from "./NameInitialsIcon.vue?vue&type=script&lang=js&"
export * from "./NameInitialsIcon.vue?vue&type=script&lang=js&"
import style0 from "./NameInitialsIcon.vue?vue&type=style&index=0&id=d528eb50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d528eb50",
  null
  
)

export default component.exports